export { createOpenAI, openai } from './openai-provider';
export type { OpenAIProvider, OpenAIProviderSettings } from './openai-provider';
export type {
  OpenAILanguageModelResponsesOptions,
  /** @deprecated Use `OpenAILanguageModelResponsesOptions` instead. */
  OpenAILanguageModelResponsesOptions as OpenAIResponsesProviderOptions,
} from './responses/openai-responses-options';
export type {
  OpenAILanguageModelChatOptions,
  /** @deprecated Use `OpenAILanguageModelChatOptions` instead. */
  OpenAILanguageModelChatOptions as OpenAIChatLanguageModelOptions,
} from './chat/openai-chat-options';
export type { OpenAILanguageModelCompletionOptions } from './completion/openai-completion-options';
export type { OpenAIEmbeddingModelOptions } from './embedding/openai-embedding-options';
export type { OpenAISpeechModelOptions } from './speech/openai-speech-options';
export type { OpenAITranscriptionModelOptions } from './transcription/openai-transcription-options';
export type {
  OpenaiResponsesProviderMetadata,
  OpenaiResponsesReasoningProviderMetadata,
  OpenaiResponsesTextProviderMetadata,
  OpenaiResponsesSourceDocumentProviderMetadata,
} from './responses/openai-responses-provider-metadata';
export { VERSION } from './version';
